import React from 'react';
import { FaqTemplate } from 'components';
import { data } from 'config/faq';

export const FaqPage = ({ t }) => (
  <FaqTemplate t={t} title={t('COMMON.FAQ')} data={data} />
);
